import type { SVGProps } from 'react';
const DawnFlagLB = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-LB_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-LB_svg__a)">
      <path fill="#F03340" d="M0 4.267h22V0H0zM0 16h22v-4.267H0z" />
      <path
        fill="#1FC065"
        d="M10.17 9.911a.444.444 0 0 0 0-.622l-.058-.06a.4.4 0 0 0-.38-.106l-.282.071c-.354.09-.577-.37-.286-.592l.27-.206A.22.22 0 0 0 9.301 8c-.232 0-.307-.312-.1-.417l.456-.233c.207-.105.132-.417-.1-.417a.22.22 0 0 1-.134-.396l1.173-.895a.67.67 0 0 1 .809 0l1.172.895a.22.22 0 0 1-.134.396c-.232 0-.306.312-.1.417l.457.233c.207.105.132.417-.1.417a.22.22 0 0 0-.134.396l.27.206c.291.222.068.683-.286.592l-.282-.071a.4.4 0 0 0-.38.106l-.058.06a.444.444 0 0 0 0 .622.444.444 0 0 1-.317.756h-1.025a.444.444 0 0 1-.317-.756"
      />
    </g>
  </svg>
);
export default DawnFlagLB;
